export default __webpack_public_path__ + "static/media/Leggings of the Ragereaver.83ca4db6.jpg";